import InPutProducts from './InPutProducts';
export default InPutProducts;